import { ColumnsByBreakpoint } from '../../helpers/columns/types';
import fluidGridColumns from '../../theme/fluidGridColumns';
import { GridItemProps } from '../Grid';

export const ctaBannerGridItemProps: GridItemProps = {
  desktop: 10,
  tabletLandscape: 10,
  tabletPortrait: fluidGridColumns.tabletPortrait,
  mobile: fluidGridColumns.mobile,
};

export const textWidthWithCtaInColumns: ColumnsByBreakpoint = {
  desktop: 5,
  tabletLandscape: 5,
  tabletPortrait: fluidGridColumns.tabletPortrait,
  mobile: fluidGridColumns.mobile,
};

export const textWidthWithoutCtaInColumns: ColumnsByBreakpoint = {
  desktop: 7,
  tabletLandscape: 7,
  tabletPortrait: fluidGridColumns.tabletPortrait,
  mobile: fluidGridColumns.mobile,
};
